/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web1920131.css";

function Web1920131(props) {
  const { overlapGroup1, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-131 screen">
        <div className="overlap-group1-11" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <div className="rectangle-2-21 border-1px-dove-gray"></div>
          <div className="overlap-group-24">
            <div className="group-141-6">
              <div className="group-140-6">
                <div className="group-139-6">
                  <img className="group-138-6" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-6" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web1920131;
